"use client";
import React from 'react';
import { useMediaQuery } from "react-responsive";
import FooterDesktop from "./Desktop/FooterDesktop";
import FooterMobile from "./Mobile/FooterMobile";

const Footer = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <footer className="relative z-10 bg-white pt-2 pb-1 dark:bg-gray-dark">
      {isMobile ? <FooterMobile /> : <FooterDesktop />}
    </footer>
  );
};

export default Footer;
